import i18n from '~/i18n';
import { validateDuplicateChannelTitle } from '~/utils/channelUtil';
import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

class ChannelForm extends Form {
  constructor(data, options, private apiProxyActions) {
    super(data, options);
  }

  options() {
    return {
      validateOnInit: true,
      validateOnChange: true,
      validateOnBlur: false,
    };
  }

  /*
    Below we are returning a `plugins` object using the `validatorjs` package
    to enable `DVR` functionalities (Declarative Validation Rules).
  */
  plugins() {
    return {
      dvr: dvr({
        package: validatorjs,
        extend: ({ validator, form }) => {
          const messages = validator.getMessages('en');
          messages['required.title'] = i18n.t('form.rule.title.required', '제목을 입력해 주세요.');
          messages.max = i18n.t('form.rule.max', ':max자 이하로 입력해 주세요.');
          validator.registerAsync('checkTitle', (value, __attr, __key, passes) => {
            if (form.$('title').isPristine || form.$('title').$initial === value.trim()) {
              passes();
            } else {
              validateDuplicateChannelTitle(this.apiProxyActions.checkDuplicateTitle, value, passes);
            }
          });
          validator.setMessages('en', messages);
        },
      }),
    };
  }

  /*
    Return the `fields` as a collection into the `setup()` method
    with a `rules` property for the validation.
  */
  setup() {
    return {
      fields: [
        {
          name: 'title',
          rules: 'required|max:30|checkTitle',
          placeholder: i18n.t('createTopicChannelModal.channelTitle.placeholder', '(필수) 대화 주제를 입력해 주세요.'),
          value: '',
        },
        {
          name: 'description',
          rules: 'max:200',
          placeholder: i18n.t(
            'createTopicChannelModal.channelDescription.placeholder',
            '설명을 입력해 주세요. (최대 200자)'
          ),
          value: '',
        },
        {
          name: 'colorCode',
          value: '',
        },
        {
          name: 'imageId',
          type: 'file',
          value: '',
        },
        {
          name: 'objectUrl',
          value: '',
        },
        {
          name: 'shared',
          value: false,
        },
      ],
    };
  }
}

export default ChannelForm;
